<template>
  <el-table
    :data="list"
    :default-expand-all="expandAll"
    :tree-props="{children: 'children'}"
    row-key="_id"
    :row-style="showRow"
    :cell-style="cellStyle"
    :max-height="maxTableHeight"
    ref="treeTable"
    highlight-current-row
    size="medium"
    border
    @row-click="handleCurrentTableRowChange">
    <el-table-column v-if="columns.length===0" width="150" >
      <template slot-scope="scope">
        {{ scope.$index }}
      </template>
    </el-table-column>
    <el-table-column v-for="(column, index) in columns" v-else :key="column.value"
    :label="column.text" :width="column.width">
      <template slot-scope="scope">
        {{ scope.row[column.value] }}
      </template>
    </el-table-column>
    <slot/>
  </el-table>
</template>

<script>
import treeToArray from "./eval";
export default {
  name: "EcTreeTable",
  props: {
    maxTableHeight: [ String, Number],
    data: {
      type: [Array, Object],
      required: true
    },
    editFormModel: {},
    columns: {
      type: Array,
      default: () => []
    },
    filterText: String,
    evalFunc: Function,
    evalArgs: Array,
    expandAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      //行样式
      rowStyle:{height: '44px'},
      //隐藏行样式
       hiddenRowStyle:{display: 'none'},
            //单元格样式
      cellStyle:{padding: '0'},
      _id: 1 // 需要 >= 0,

    }
  },
  computed: {
    // 格式化数据源
    list: function() {
      let tmp;
      if (!Array.isArray(this.data)) {
        tmp = [this.data];
      } else {
        tmp = this.data;
      }
      this.addId(tmp)
      const func = this.evalFunc || treeToArray;
      const args = this.evalArgs
        ? Array.concat([tmp, this.expandAll], this.evalArgs)
        : [tmp, this.expandAll];
      return func.apply(null, args)
    }
  },
  methods: {
    handleCurrentTableRowChange(val) {
      let _this = this;
      _this.$emit("changeRow", val);
    },
    addId (data) {
      if (!data || data.length < 1) return data;
      data.forEach((ele, index) => {
        ele._id = this.$data._id++
        if (ele.children && ele.children.length)
          {
            this.addId(ele.children)
          }
      })
    },
    showRow: function(row) {
      let _this = this;
      let show = true;
      show = row.row.parent
        ? row.row.parent._expanded && row.row.parent._show
        : true;
      if(_this.filterText){
        show = _this.checkIndexOfData(row.row,_this.filterText)
      }
      row.row._show = show;
      return show?_this.rowStyle:_this.hiddenRowStyle;
    },
    checkIndexOfData(obj,filterText) {
      let show = false;
      //当前节点存在
      if((obj.permisName).indexOf(filterText) !== -1){
        show = true
        //直接返回
        return show;
      }
      //不存在
      //若有子节点
      if(obj.children!=null){
        //遍历子节点
        for (const ch of obj.children) {
          //子节点拥有
          if((ch.permisName).indexOf(filterText) !== -1){
            show = true;
            break;
          }
          //子节点拥有子节点
          if(ch.children!=null){
            //遍历子节点
            for (const ld of ch.children) {
              if((ld.permisName).indexOf(filterText) !== -1){
                show = true;
                break;
              }
            }
          }
          if(show) break;
        }
      }
      return show;
    }
  }
};
</script>
<style rel="stylesheet/css">
@keyframes treeTableShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes treeTableShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>

<style lang="scss" rel="stylesheet/scss" scoped>
$color-blue: #2196f3;
$space-width: 18px;
.ms-tree-space {
  position: relative;
  top: 100px;
  display: inline-block;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  width: $space-width;
  height: 14px;
  &::before {
    content: "";
  }
}
.processContainer {
  width: 100%;
  height: 100%;
}
table td {
  line-height: 26px;
}
/**增加后，列表中多余的横线则不显示 */
.el-table::before {
     z-index: inherit;
    //或者设置height为0px
     //height: 0px;
}
.tree-ctrl {
  position: relative;
  cursor: pointer;
  color: $color-blue;
  margin-left: -$space-width;
}
</style>



// WEBPACK FOOTER //
// src/components/EcTreeTable/src/treeTable.vue